<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div style="margin-left: -2rem;margin-right: -2rem;">
        <b-breadcrumb :items="items" v-if="thai_student==1  && current_postpone==0" />
        <b-breadcrumb :items="items70" v-if="thai_student==1 && current_postpone==1" />
        <b-breadcrumb :items="items_eng" v-if="thai_student==0 && current_postpone==0" />
        <b-breadcrumb :items="items_eng70" v-if="thai_student==0 && current_postpone==1" />
      </div>
      <create-bio></create-bio>
      <create-post></create-post>
    </div>
  </div>
</template>

<script>
import CreatePost from "../../components/CreatePost.vue";
import CreateBio from "../../components/CreateBio.vue";

export default {
  components: {
    CreatePost,
    CreateBio
  },
  name: "Post",
  data() {
    return {
      items: [
        {
          text: "หน้าหลัก",
          href: "#/Main"
        },
        {
          text: "แจ้งความประสงค์เข้ารับปริญญาบัตร",
          href: "#"
        }
      ],
      items70: [
        {
          text: "หน้าหลัก",
          href: "#/Main70"
        },
        {
          text: "แจ้งความประสงค์เข้ารับปริญญาบัตร",
          href: "#"
        }
      ],
      items_eng: [
        {
          text: "Home",
          href: "#/Main"
        },
        {
          text: "Confirmation to attend the commencement ceremony",
          href: "#"
        }
      ],
      items_eng70: [
        {
          text: "Home",
          href: "#/Main70"
        },
        {
          text: "Confirmation to attend the commencement ceremony",
          href: "#"
        }
      ],
      categorey: [],
      current_postpone:0,
    };
  },
  methods: {},
  mounted() {},
  created() {
    this.thai_student = this.$store.state.user.thaistudent;
    this.current_postpone= this.$store.state.user.postpone_status;
  }
};
</script>
<style></style>
